<template>
  <a-card title="Cálculo Exercícios">
    <form ref="form" @submit.prevent="submitForm">
      <div class="row">
        <div class="col-md-6">
          <label for="cpf">Exercício</label><label style="font-weight: bold; color: red">*</label>
          <div class="input-group input-focus select-height">
            <select class="form-select form-input-component" ref="exercicio" v-model="registro.exercicio" v-bind:class="{ 'is-invalid': submitted && !registro.exercicio }">
              <option v-for="item in tipoExercicios" :key="item" :value="item">
                {{ item.descricao }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <a-divider type="horizontal" />

      <fieldset class="fieldset-custom">
        <legend style="width: 160px">Dados Cálculo</legend>
        <div class="row">
          <div class="col-md-4">
            <label for="cpf">Sexo Mílitar</label><label style="font-weight: bold; color: red">*</label>
            <div class="input-group input-focus">
              <select v-bind:class="{ 'is-invalid': submittedCalculo && !calculo.sexo }" class="form-select form-input-component" ref="sexoMilitar" v-model="calculo.sexo">
                <option v-for="item in sexos" :key="item" :value="item">
                  {{ item.descricao }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-4">
            <label for="nome">Quantidade</label><label style="margin-left: 1px; font-weight: bold; color: red">*</label>
            <br />
            <input v-bind:class="{ 'is-invalid': submittedCalculo && !calculo.quantidade }" v-model="calculo.quantidade" type="text" class="form-control form-input-component" />
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <label for="cpf">Faixa etária</label><label style="font-weight: bold; color: red">*</label>
            <div class="input-group input-focus">
              <select class="form-select form-input-component" ref="faixasEtarias" v-bind:class="{ 'is-invalid': submittedCalculo && !calculo.faixaEtaria }" v-model="calculo.faixaEtaria">
                <option v-for="item in faixasEtarias" :key="item" :value="item">
                  {{ item.nome }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-4">
            <label for="nome">Fórmula</label><label style="margin-left: 1px; font-weight: bold; color: red">*</label>
            <br />
            <input v-model="calculo.formula" type="text" class="form-control form-input-component" v-bind:class="{ 'is-invalid': submittedCalculo && !calculo.formula }" />
          </div>
        </div>
        <div class="row">
          <div class="col-md-8">
            <label for="nome">Resultado</label><label style="margin-left: 1px; font-weight: bold; color: red">*</label>
            <br />
            <input v-model="calculo.resultado" type="text" class="form-control form-input-component" v-bind:class="{ 'is-invalid': submittedCalculo && !calculo.resultado }" />
          </div>
        </div>
        <div class="row" style="margin-top: 8px">
          <div class="col-md-8">
            <label for="nome">Q = Quantidade de exercícios informada pelo usuário.</label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-8">
            <label for="nome">C = Resultado da aplicação da fórmula.</label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-8">
            <label for="nome">OU = Operador para pelo menos um valor verdadeiro.</label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-8">
            <label for="nome">E = Operador para todos valores verdadeiros.</label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <br />
            <button type="button" class="btn btn-primary" @click="selecionarItem">Incluir</button>
          </div>
        </div>
        <br />
        <div class="row" v-show="registro.calculos.length > 0">
          <div class="col-md-8">
            <a-table :dataSource="registro.calculos" :columns="columns">
              <template #action="{ record }">
                <a title="Editar" @click="editarItem(record)"><i class="fas fa-edit icon-edit"></i></a>&nbsp;
                <a title="Opções" @click="removerItem(record)"><i class="fas fa-trash icon-trash"></i></a>
              </template>
            </a-table>
          </div>
        </div>
      </fieldset>

      <a-divider type="horizontal" />
      <div class="spaced-container">
        <button type="submit" class="btn btn-primary" @click="cadastrar()">Salvar</button>
        <button class="btn btn-warning" @click="voltar">Voltar</button>
      </div>
    </form>
  </a-card>
</template>

<script>
import { EnumTipoExercicio } from '@/components/models/enumTipoExercicio';
import { EnumSexo } from '@/components/models/enumSexo';
import { openNotification, typesNotification } from '@/utils/notifications';
import { create, getById } from '@/components/service/parametroTafCalculoExercicioService';
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { getFaixasExtarias } from '@/components/service/faixaEtariaService';
export default {
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      especialidades: [],
      especialidadesFiltro: [],
      tipoExercicios: EnumTipoExercicio(),
      sexos: EnumSexo(),
      faixasEtarias: [],
      selecionarNome: '',
      nomeSelecionado: null,
      idSelecionado: null,
      submitted: false,
      submittedCalculo: false,

      registro: {
        calculos: [],
      },
      calculoEditar: null,
      calculo: {
        identificador: undefined,
        sexo: undefined,
        faixaEtaria: undefined,
        quantidade: undefined,
        formula: undefined,
        resultado: undefined,
      },

      columns: [
        {
          title: '',
          dataIndex: 'identificador',
          key: 'identificador',
          slots: { customRender: 'identificador' },
        },
        {
          title: 'Sexo',
          dataIndex: 'sexo.descricao',
          key: 'sexo.descricao',
          slots: { customRender: 'sexo' },
        },
        {
          title: 'Faixa Etária',
          dataIndex: 'faixaEtaria.nome',
          key: 'faixaEtaria.nome',
          slots: { customRender: 'faixaEtaria' },
        },
        {
          title: 'Quantidade',
          dataIndex: 'quantidade',
          key: 'quantidade',
          slots: { customRender: 'quantidade' },
        },
        {
          title: 'Fórmula',
          dataIndex: 'formula',
          key: 'formula',
          slots: { customRender: 'formula' },
        },
        {
          title: 'Resultado',
          dataIndex: 'resultado',
          key: 'resultado',
          slots: { customRender: 'resultado' },
        },
        {
          title: 'Ações',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
    };
  },
  validations() {
    return {
      registro: {
        exercicio: {
          required,
        },
      },
      calculo: {
        sexo: {
          required,
        },
        quantidade: {
          required,
        },
        faixaEtaria: {
          required,
        },
        formula: {
          required,
        },
        resultado: {
          required,
        },
      },
    };
  },
  methods: {
    async cadastrar() {
      if (this.v$.registro.$invalid) {
        this.submitted = true;
        openNotification(typesNotification.warning, 'Informe os campos obrigatórios!');
      } else if (this.registro.calculos.length == 0) {
        openNotification(typesNotification.warning, 'Você deve incluir pelo menos um cálculo para cadastrar o exercício!');
      } else {
        let registroPost = { ...this.registro };
        await create(registroPost).then(() => {
          //let retorno = r.data;
          if (!this.registro.id) {
            openNotification(typesNotification.success, 'Dados salvos com sucesso.');
          } else {
            openNotification(typesNotification.success, 'Dados alterados com sucesso.');
          }
          this.itensSelecionados = [];
          this.submitted = false;
          this.registro = { calculos: [] };
        });
      }
    },
    removerItem(record) {
      const index = this.registro.calculos.indexOf(record);
      if (index > -1) {
        this.registro.calculos.splice(index, 1);
        this.registro.calculos.forEach((c, index) => {
          c.identificador = index + 1;
        });
      }
    },
    selecionarItem() {
      if (!this.v$.calculo.$invalid) {
        if (this.calculoEditar != null) {
          this.registro.calculos.splice(
            this.registro.calculos.findIndex((obj) => obj.identificador === this.calculoEditar.identificador),
            1,
            this.calculo
          );
        } else {
          this.calculo.identificador = this.registro.calculos.length + 1;
          this.registro.calculos.push(this.calculo);
        }
        this.calculo = {};
        this.calculoEditar = null;
        this.submittedCalculo = false;
      } else {
        this.submittedCalculo = true;
        openNotification(typesNotification.warning, 'Preencha os dados do cálculo!');
      }
    },
    editarItem(record) {
      this.calculo = { ...record };
      this.calculoEditar = { ...record };
    },
    voltar() {
      this.$router.go(-1);
    },
    async carregar() {
      if (this.$route.query.id) {
        const idUrl = this.$route.query.id;
        const res = await getById(idUrl);
        this.registro = { ...res.data, id: idUrl };
      }
    },
  },
  async created() {
    let reponse = await getFaixasExtarias();
    Object.assign(this.faixasEtarias, reponse.data);
    this.carregar();
  },
};
</script>

<style>
.input-group-text {
  height: 38px;
}

.input-group-prepend {
  cursor: pointer;
  margin-left: 8px !important;
}

.input-group-text:hover {
  background-color: #e0e0e0 !important;
}

.h2 {
  font-size: x-large;
}

.spaced-container * {
  margin-top: 10px;
  margin-right: 10px;
}
</style>
